"use client";
import { useSelectedLayoutSegment } from 'next/navigation';
import dynamic from 'next/dynamic';

const NavBar = dynamic(() => import('../nav-bar/navBar'));
const Footer = dynamic(() => import('../footer/footer'), { ssr: false });
const ChatWithAi = dynamic(() => import('../chatWithAi/chatWithAi'), { ssr: false });

export default function RootLayoutClient({ children }) {
    const segment = useSelectedLayoutSegment();
    const hideLayoutFor = ["application", "smsf-loan", "commercial-finance-loan", "reverse-mortgage-loan"];
    const hideNavBarFor = ["application"];
    
    const shouldHideNavBar = hideNavBarFor.includes(segment);
    const shouldHideFooter = hideLayoutFor.includes(segment);

    return (
        <>
            {!shouldHideNavBar && <NavBar />}
            {children}
            {!shouldHideFooter && <Footer />}
            <ChatWithAi />
        </>
    );
}
